import { Phone } from "lucide-react";
import { SITE } from "@/lib/site";

export default function FloatingCall() {
  return (
    <a
      href={SITE.phoneHref}
      data-testid="floating-call-button"
      aria-label={`Sună la ${SITE.phoneDisplay}`}
      className="md:hidden fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-[#048a93] text-white shadow-2xl shadow-[#048a93]/40 flex items-center justify-center active:scale-95 transition-all"
    >
      <span className="absolute inset-0 rounded-full bg-[#048a93] animate-ping opacity-30" />
      <Phone className="h-6 w-6 relative" />
    </a>
  );
}
